import React from "react";
import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import Icon from "@mui/material/Icon";

// Multi-lingual support
import { t } from "i18next";

// Hooks
import { useUser } from "../../hooks/useUserContext/useUserContext";

// Types
import { EUserRoles } from "../shared/commonTypes/commonTypes";

// Get package json file
import packageJson from "../../../package.json";

interface IListItems {
  to: string;
  icon: string;
  label: string;
}

const LeftSideBar: React.FC = () => {
  const { user } = useUser();
  const location = useLocation(); // Get current URL dynamically

  let navItems = Array<IListItems>();
  if (user?.role === EUserRoles.admin) {
    navItems = [
      {
        to: "/admindashboard",
        icon: "icon-dashboard-1",
        label: t("leftSideBar.dashboard"),
      },
      { to: "/users", icon: "icon-myteam", label: t("leftSideBar.myTeam") },
      {
        to: "/farmers",
        icon: "icon-farmerdata",
        label: t("leftSideBar.farmersData"),
      },
      {
        to: "/formbuilders",
        icon: "icon-masterdata",
        label: t("leftSideBar.formBuilder"),
      },
      {
        to: "/pendingRequest",
        icon: "icon-pendingrequest",
        label: t("leftSideBar.pendingRequest"),
      },
      {
        to: "/yieldconfig",
        icon: "icon-settings",
        label: t("leftSideBar.settings"),
      },
      // { to: "/formdesigner", icon: "icon-formdesign", label: "Form Designer" },
      // {
      //   to: "/submittedform",
      //   icon: "icon-submittedform",
      //   label: "Submitted Forms",
      // },
      // {
      //   to: "/pendingrequest",
      //   icon: "icon-pendingrequest",
      //   label: "Pending Request",
      // },
      // { to: "/buyingactivity", icon: "icon-buying", label: "Buying Activity" },
      // { to: "/masterdata", icon: "icon-masterdata", label: "Master Data" },
      // { to: "/useraccount", icon: "icon-useraccount", label: "User Account" },
    ];
  }
  if (user?.role === EUserRoles.manager) {
    navItems = [
      {
        to: "/admindashboard",
        icon: "icon-dashboard-1",
        label: t("leftSideBar.dashboard"),
      },
      { to: "/users", icon: "icon-myteam", label: t("leftSideBar.myTeam") },
      {
        to: "/farmers",
        icon: "icon-farmerdata",
        label: t("leftSideBar.farmersData"),
      },
      {
        to: "/pendingRequest",
        icon: "icon-pendingrequest",
        label: t("leftSideBar.pendingRequest"),
      },
    ];
  }
  if (user?.role === EUserRoles.agent) {
    navItems = [
      {
        to: "/admindashboard",
        icon: "icon-dashboard-1",
        label: t("leftSideBar.dashboard"),
      },
      {
        to: "/farmers",
        icon: "icon-farmerdata",
        label: t("leftSideBar.farmersData"),
      },
    ];
  } else if (user?.role === EUserRoles.superAdmin) {
    navItems = [
      {
        to: "/masters",
        icon: "icon-masterdata",
        label: t("leftSideBar.masterData"),
      },
    ];
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <nav className="sidebar">
        <List>
          {navItems.map((item) => {
            const isActive =
              location.pathname === item.to ||
              (location.pathname.startsWith("/formbuilder") &&
                item.to === "/formbuilders") ||
              (location.pathname.startsWith("/fieldDetails") &&
                item.to === "/pendingRequest") ||
              ((location.pathname.startsWith("/managefarmers") ||
                location.pathname.startsWith("/addField")) &&
                item.to === "/farmers");
            return (
              <ListItem
                component={Link}
                to={item.to}
                className={`sidebar-item ${isActive ? "active" : ""}`}
                key={item.to}
              >
                <Icon className={`sidebar-icon ${item.icon}`} />
                <ListItemText primary={item.label} className="sidebar-text" />
              </ListItem>
            );
          })}
        </List>
      </nav>
      {/* App Version */}
      <Typography
        variant="body2"
        sx={{
          color: "farm.contrastText",
          display: "flex",
          justifyContent: "center",
          marginBottom: 2,
        }}
      >
        v {packageJson.version}
      </Typography>
    </Box>
  );
};

export default LeftSideBar;
